import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AiIcon from '../../../../components/icons/Ai';
import Markdown from '../../../../components/Markdown';
import { ChatButton, UnreadChannels } from '../../../chat';
import { MessageWithAssistant } from '../../types';

import './styles.css';

interface ButtonText {
  title: string;
  text: string;
  assistantId: string;
  threadId?: string;
}

interface FloatingButtonProps {
  isTeamChatVisible: boolean;
  newMessages?: MessageWithAssistant[];
  onClick: (assistantId?: string, threadId?: string) => void;
}

const FloatingButton = (props: FloatingButtonProps) => {
  const { isTeamChatVisible, newMessages, onClick } = props;
  const [message, setMessage] = useState<ButtonText | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (newMessages?.length) {
      const message = newMessages[newMessages.length - 1]!;
      console.log(message.thread);
      setMessage({
        title: message.assistantName,
        text: (message.content || message.suggestion) as string,
        assistantId: message.assistantId,
        threadId: message.thread?.id,
      });
      setTimeout(() => {
        setMessage(null);
      }, 10000);
    } else {
      setMessage(null);
    }
  }, [newMessages]);

  return (
    <ChatButton
      style={{
        marginBottom: isTeamChatVisible ? '60px' : '0px',
        background: '#E6EBF7',
      }}
      data-hover={t("virtualAssistant.va")}
      onClick={() => {
        onClick(message?.assistantId, message?.threadId);
      }}
    >
      {message && (
        <div className="chat-widget--bubble">
          <h1 className="chat-widget--header">{message.title}</h1>
          <p className="chat-widget--text">
            <Markdown markdown={message.text} nOfLines={5} />
          </p>
        </div>
      )}
      {newMessages?.length ? (
        <UnreadChannels>
          {newMessages.length > 9 ? '9+' : newMessages.length}
        </UnreadChannels>
      ) : null}
      <AiIcon boxSize="24px" />
    </ChatButton>
  );
};

export default FloatingButton;
